import React from 'react';
import Hero from '../UI/Hero/Hero';
import overviewImg from '../../Assets/Images/img12.png';
import Aux from '../../Hoc/Aux/Aux';
import classes from './Overview.css';
import Footer from '../Footer/Footer';
import Slider from '../../Containers/Slider/Slider';
import data from '../../OverviewData';
import Img from '../../Assets/Images/flash1.png';
import { Link } from 'react-router-dom';

const overview = (props) => {
    // console.log('[data]', data);

    const title = data.map(item => {
        return item.title;
    });
    const overview = data.map(item => {
        return item.overview;
    });
    const date = data.map(item => {
        return item.date;
    });

    const styles = {
        backgroundColor: 'transparent',
        backgroundImage: 'url('+Img+')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
    };

    return (
        <Aux>
            <Hero title="Program OverView"
                  classType="hero-overview"
                  img={overviewImg}
            />
            <section style={{}}>
                <div className={["tile", classes.Parent].join(' ')}>
                    <div className={["content", classes.Overview].join(' ')}>
                        <div className={classes.GridContainer}>
                            <div className={classes.Circle}>
                                <h1>{date}</h1>
                            </div>
                            <div className={classes.Circle}>
                                <h1 className="">{title}</h1>
                            </div>
                        </div>

                        <p style={{fontSize: '22px'}}>{overview}</p>

                        <div className={classes.Info}>
                            <div className={classes.InfoInner}>
                                <div className="title">GET MORE INFO</div>
                                <Link className={classes.Button} to="/events">CONTINUE</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section style={styles}>
                <div className={["content", classes.Overview].join(' ')}>
                    <div>
                        <Slider data={data}/>
                    </div>
                </div>
            </section>

            <Aux>
                <Footer />
            </Aux>
        </Aux>
    )
};

export default overview;


// WEBPACK FOOTER //
// ./src/Components/Overview/Overview.js